import { Dumbbell, Clock, MapPin, Phone, Shield, Users, Zap, ChevronRight } from "lucide-react";
import gymHero from "@/assets/gym-hero.jpg";

const features = [
  { icon: Dumbbell, title: "Опрема", desc: "Тегови, бенч клупа, вратило, разбој и повеќе" },
  { icon: Users, title: "Приватна Сесија", desc: "Целата теретана е твоја — без чекање, без делење" },
  { icon: Shield, title: "Чисто и Безбедно", desc: "Дезинфицирано пред секоја сесија, целосно опремено" },
  { icon: Zap, title: "Флексибилни Часови", desc: "Резервирај кој било час, 7 дена во неделата" },
];

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Навигација */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-md border-b border-border">
        <div className="container flex items-center justify-between h-16">
          <span className="font-display text-2xl tracking-wider text-primary">BASEMENT FITNESS</span>
          <a
            href="#book"
            className="bg-primary text-primary-foreground px-5 py-2 rounded-sm font-semibold text-sm hover:opacity-90 transition-opacity"
          >
            Резервирај
          </a>
        </div>
      </nav>

      {/* Херо */}
      <section className="relative min-h-screen flex items-center pt-16">
        <div className="absolute inset-0">
          <img src={gymHero} alt="Подрумска теретана со професионална опрема" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-background via-background/90 to-background/40" />
        </div>
        <div className="container relative z-10 py-20">
          <div className="max-w-2xl">
            <p className="text-primary font-semibold tracking-widest uppercase text-sm mb-4 animate-fade-in-up">
              Приватна Теретана · Радишани, Скопје
            </p>
            <h1 className="font-display text-6xl md:text-8xl leading-[0.9] mb-6 animate-fade-in-up" style={{ animationDelay: "0.1s" }}>
              ТВОЈА ТЕРЕТАНА.<br />
              <span className="text-gradient">ТВОЈ ЧАС.</span>
            </h1>
            <p className="text-muted-foreground text-lg md:text-xl max-w-lg mb-10 animate-fade-in-up" style={{ animationDelay: "0.2s" }}>
              Целосно опремена приватна подрумска теретана во Радишани која можеш да ја изнајмиш за само 1 час.
              Без гужви. Без одвлекување. Само ти и железото.
            </p>
            <div className="flex flex-wrap gap-4 animate-fade-in-up" style={{ animationDelay: "0.3s" }}>
              <a
                href="#book"
                className="bg-primary text-primary-foreground px-8 py-4 rounded-sm font-bold text-lg hover:opacity-90 transition-opacity inline-flex items-center gap-2 glow-accent"
              >
                Резервирај Термин <ChevronRight className="w-5 h-5" />
              </a>
              <a
                href="#features"
                className="border border-border text-foreground px-8 py-4 rounded-sm font-semibold text-lg hover:bg-secondary transition-colors"
              >
                Погледни Опрема
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Карактеристики */}
      <section id="features" className="py-24 border-t border-border">
        <div className="container">
          <h2 className="font-display text-5xl md:text-6xl text-center mb-4">ЗОШТО ТУКА</h2>
          <p className="text-muted-foreground text-center mb-16 max-w-md mx-auto">
            Сè што ти треба за сериозен тренинг, во приватна средина.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {features.map((f) => (
              <div key={f.title} className="bg-card border border-border rounded-lg p-8 hover:border-primary/50 transition-colors group">
                <f.icon className="w-10 h-10 text-primary mb-5 group-hover:scale-110 transition-transform" />
                <h3 className="font-display text-2xl mb-2">{f.title}</h3>
                <p className="text-muted-foreground text-sm">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Цена */}
      <section className="py-24 border-t border-border">
        <div className="container max-w-2xl text-center">
          <h2 className="font-display text-5xl md:text-6xl mb-4">ЕДНОСТАВНА ЦЕНА</h2>
          <p className="text-muted-foreground mb-12">Без членарини. Без обврски. Плати по сесија.</p>
          <div className="bg-card border border-primary/30 rounded-xl p-12 glow-accent">
            <div className="flex items-center justify-center gap-2 mb-2">
              <Clock className="w-6 h-6 text-primary" />
              <span className="text-muted-foreground font-medium">1 Час Сесија</span>
            </div>
            <div className="font-display text-7xl md:text-8xl text-primary mb-2">100 ДЕН</div>
            <p className="text-muted-foreground text-sm mb-8">≈ €1.6 · Целосен пристап · Сета опрема вклучена</p>
            <a
              href="#book"
              className="bg-primary text-primary-foreground px-10 py-4 rounded-sm font-bold text-lg hover:opacity-90 transition-opacity inline-block"
            >
              Резервирај Час
            </a>
          </div>
        </div>
      </section>

      {/* Локација и Контакт */}
      <section id="book" className="py-24 border-t border-border">
        <div className="container">
          <h2 className="font-display text-5xl md:text-6xl text-center mb-16">НАЈДИ НÈ И РЕЗЕРВИРАЈ</h2>
          <div className="grid md:grid-cols-2 gap-12 max-w-4xl mx-auto">
            {/* Мапа */}
            <div className="rounded-xl overflow-hidden border border-border aspect-square">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2963.023812750278!2d21.44855737666275!3d42.04273035513253!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13541459422a579d%3A0x6b44760d606f366e!2zUmFkacWhYW5za2EgMTQsIFNrb3BqZSAxMDAw!5e0!3m2!1sen!2smk!4v1709650000000!5m2!1sen!2smk"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Локација на теретаната во Радишани, Скопје"
              />
            </div>

            {/* Контакт */}
            <div className="flex flex-col justify-center gap-8">
              <div>
                <div className="flex items-center gap-3 mb-3">
                  <MapPin className="w-6 h-6 text-primary" />
                  <h3 className="font-display text-2xl">ЛОКАЦИЈА</h3>
                </div>
                <p className="text-muted-foreground ml-9">
                  Ул. Радишанска бр. 14, Куќа бр. 5<br />
                  Радишани, Скопје<br />
                  Македонија
                </p>
              </div>
              <div>
                <div className="flex items-center gap-3 mb-3">
                  <Phone className="w-6 h-6 text-primary" />
                  <h3 className="font-display text-2xl">КОНТАКТ</h3>
                </div>
                <p className="text-muted-foreground ml-9">
                  Јави се или порачај термин:<br />
                  <a href="tel:+38970803787" className="text-primary hover:underline font-semibold">
                    +389 70 803 787
                  </a>
                </p>
              </div>
              <div>
                <div className="flex items-center gap-3 mb-3">
                  <svg className="w-6 h-6 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="20" x="2" y="2" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/></svg>
                  <h3 className="font-display text-2xl">INSTAGRAM</h3>
                </div>
                <p className="text-muted-foreground ml-9">
                  Заследете нè за повеќе слики и видеа:<br />
                  <a href="https://www.instagram.com/BasementFitnessMK" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline font-semibold">
                    @BasementFitnessMK
                  </a><br />
                  Пишете ни во DM за резервација!
                </p>
              </div>
              <div>
                <div className="flex items-center gap-3 mb-3">
                  <Clock className="w-6 h-6 text-primary" />
                  <h3 className="font-display text-2xl">РАБОТНО ВРЕМЕ</h3>
                </div>
                <p className="text-muted-foreground ml-9">
                  Достапно 7 дена во неделата<br />
                  06:00 – 22:00
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Футер */}
      <footer className="border-t border-border py-8">
        <div className="container text-center text-muted-foreground text-sm">
          © 2026 Basement Fitness · Скопје, Македонија
        </div>
      </footer>
    </div>
  );
};

export default Index;
